import { ApiEndpointClient } from './resource-client';
export class ConstructionIndicesClient extends ApiEndpointClient {
    constructor(http) {
        super(http, 'valuation-api/v1');
    }
    getConstructionIndices = async ({ indexType }, options) => {
        return this.get('/construction-indices/', {
            query: { index_type: indexType },
            signal: options?.signal,
        });
    };
}
